/* tslint:disable:indent */
import {CritereFormulaire} from './critere-formulaire';
import {Flux} from './flux';
import {Formulaire} from './formulaire';
import {StatutAvisEnum} from './enums/statut-avis.enum';
import {Annonce} from '../modules/formulaires/common/models/annonce';
import {User} from '../modules/administration/models/user';
import {Annonceur} from './annonceur';
import {ContenuPdf} from '../modules/formulaires/common/models/contenuPdf';


export class Avis {

  public avisId: number;
  public reference: string;
  public critere: CritereFormulaire;
  public refConsultation: String;
  public refAvisLie: String;
  public refAvisDuplique: string;
  public refAvisConnexe: string;
  public codeCpvFormulaire: String;
  public nbLots: Number;
  public jsonSaisieFormulaire: Annonce;
  public adrContactJAL: string;
  public dateCreation: Date;
  public statut: StatutAvisEnum;
  public datePublication: Date;
  public dateRejet: Date;
  public formulaire: Formulaire;
  public telecopieur: string;
  public adresseFacturation: string;
  public idBoampweb: string;
  public mdpBoampweb: string;
  public mailBoampweb: string;
  public dateModification: Date;
  public flux: Array<Flux>;
  public user: User;
  public annonceur: Annonceur;
  public jsonPdf: ContenuPdf;
  public motifModification: string;
  public jsonFieldsErrorsWarnings: any;
  public jsonCSV: any;
  public intituleDuMarche: string;
  public eformIdParentNotice: string;
  public hasAvisLies: boolean;

  constructor() {
    this.critere = new CritereFormulaire();
    this.formulaire = new Formulaire();
    this.flux = [];
  }
}
